import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useCallback } from 'react';

export const useTour = () => {
    const location = useLocation();
    const mode = useSelector(state => state.mode?.mode || 'public');

    const getSteps = useCallback(() => {
        const path = location.pathname;

        if (path === '/dashboard') {
            if (mode === 'private') {
                return [
                    {
                        element: '#tour-token-table',
                        popover: {
                            title: 'Kaxaa Private eWallets',
                            description: 'Kaxaa Private eWallets supports ERC-20 tokens.',
                            side: "bottom",
                            align: 'end'
                        }
                    },
                    {
                        element: '#tour-action-menu',
                        popover: {
                            title: 'Private Action - <b>Private Transfer</b>',
                            description: '<b>Private transfer</b> sends are valid blockchain transactions that transfer value without revealing sender, recipient, amount, or token type. It lets you securely move assets from one Kaxaa private wallet to another. You’ll need the recipient’s address.',
                            side: "bottom",
                            align: 'end'
                        }
                    },
                    {
                        element: '#tour-action-menu',
                        popover: {
                            title: 'Private Actions - <b>Token Detail Page</b>',
                            description: 'Token Detail Page provides coin price, historical price  data, contract address, transaction history, and trading functions.',
                            side: "bottom",
                            align: 'end'
                        }
                    },
                    {
                        element: '#tour-action-menu',
                        popover: {
                            title: 'Private Action - <b>UnShield</b>',
                            description: 'Unshield your ERC‑20 tokens to move them into your public wallet so you can transfer them to external wallets or swap them.',
                            side: "bottom",
                            align: 'end'
                        }
                    },
                    {
                        element: '#tour-balance-card',
                        popover: {
                            title: 'Private Balance',
                            description: 'View your total private balance across all integrated blockchains. Displayed in both KAXAA and USD value.',
                            side: "bottom",
                            align: 'end'
                        }
                    },
                    {
                        element: '#tour-private-sync',
                        popover: {
                            title: 'Sync Private Wallet',
                            description: 'Sync your private wallet in case it is not showing.',
                            side: "bottom",
                            align: 'end'
                        }
                    },
                    {
                        element: '#tour-history-aside-link',
                        popover: {
                            title: 'History',
                            description: 'View and track all your Private Transactions (shield, unsheild and private transfer) History on each blockchain network.',
                            side: "bottom",
                            align: 'start'
                        }
                    }
                ];
            } else {
                return [
                    {
                        element: '#tour-token-polygon',
                        popover: {
                            title: 'Polygon Setup',
                            description: 'To help you get started, we’ve dropped 1 POL token into your wallet for Polygon chain gas fees.',
                            side: "bottom",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-token-table',
                        popover: {
                            title: 'Kaxaa eWallets',
                            description: 'Kaxaa PiggyBank supports various blockchain networks and their tokens.',
                            side: "bottom",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-buy-container',
                        popover: {
                            title: 'Buy Crypto',
                            description: 'Purchase tokens directly through our integrated on-ramp partners.',
                            side: "bottom",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-action-menu',
                        popover: {
                            title: 'Public Actions - <b>Send and Receive</b>',
                            description: '<b>Send and receive</b> tokens from this dropdown menu.',
                            side: "bottom",
                            align: 'end'
                        }
                    },
                    {
                        element: '#tour-action-menu',
                        popover: {
                            title: 'Public Actions - <b>Token Detail Page</b>',
                            description: '<b>Token Detail Page</b> provides coin price, historical price  data, contract address, transaction history, and trading functions.',
                            side: "bottom",
                            align: 'end'
                        }
                    },
                    {
                        element: '#tour-action-menu',
                        popover: {
                            title: 'Public Actions - <b>Shield</b>',
                            description: '<b>Shielding</b> encrypts your activity, address, and assets with Zero-Knowledge cryptography.',
                            side: "bottom",
                            align: 'end'
                        }
                    },
                    {
                        element: '#tour-balance-card',
                        popover: {
                            title: 'Public Balance',
                            description: 'View your total public balance across all integrated blockchains. Displayed in both KAXAA and USD value.',
                            side: "bottom",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-history-aside-link',
                        popover: {
                            title: 'Transaction History',
                            description: 'View and track all your transaction history on each blockchain network.',
                            side: "bottom",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-history-swap-link',
                        popover: {
                            title: 'Swap Your Tokens',
                            description: 'Use our trading platform to swap crypto between KAXAA and supported tokens.',
                            side: "bottom",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-mode-switch',
                        popover: {
                            title: 'Your Kaxaa eWallet Switch',
                            description: 'The Kaxaa PiggyBank offers a toggle switch between your public and private Wallet.  Protect your tokens using shielding and unshielding functions to transfer & protect your ERC-20 tokens from public view.',
                            side: "bottom",
                            align: 'start'
                        }
                    }
                ];
            }
        } else if (path.startsWith('/coin/')) {
            return [
                {
                    element: '#tour-coin-details',
                    popover: {
                        title: 'Token Info',
                        description: 'Provides real-time price, historical charts, contract address, and transaction history for this token.',
                        side: "bottom",
                        align: 'start'
                    }
                }
            ];
        } else if (path === '/history') {
            return [
                {
                    element: '#tour-chain-selector',
                    popover: {
                        title: 'Filter by Network',
                        description: 'Select a specific blockchain network to filter your transaction history.',
                        side: "bottom",
                        align: 'start'
                    }
                },
                {
                    element: '#tour-history-table',
                    popover: {
                        title: 'Record History',
                        description: 'A detailed list of all your incoming and outgoing transactions.',
                        side: "bottom",
                        align: 'start'
                    }
                }
            ];
        }

        return [];
    }, [location.pathname, mode]);

    const startTour = useCallback((force = true) => {
        const steps = getSteps();
        if (steps.length === 0) return;

        let path = location.pathname.replace('/', '') || 'dashboard';
        
        // For all coin detail pages, use the same key to prevent auto-tour on other coins
        if (path.startsWith('coin/')) {
            path = 'coin'; // Use generic 'coin' key for all coin pages
        }
        
        const tourKey = `kaxaa_tour_${path}_${mode}_seen`;

        if (!force && localStorage.getItem(tourKey)) return;

        const driverObj = driver({
            showProgress: true,
            steps: [
                ...steps,
                {
                    popover: {
                        title: 'Walkthrough Complete!',
                        description: 'You are all set to use your Kaxaa wallet. Feel free to restart this tour anytime from the header!',
                    }
                }
            ],
            onDestroyed: () => {
                localStorage.setItem(tourKey, "true");
            }
        });

        driverObj.drive();
    }, [getSteps, location.pathname, mode]);

    return { startTour };
};

export const useTourPrivate = () => {
    // We now use the same unified useTour hook which handles mode internally
    return useTour();
};
